module.exports = __webpack_public_path__ + "static/img/pic_pico03@2x.2595e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_pico03@2x.png
// module id = MvtC
// module chunks = 0